import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { COLOR_PALETTE, GLOBAL_STATE } from '../constants/actionTypes'

const selector = (state: RootState) => prop(GLOBAL_STATE, state)

export const colorPaletteSelector = createSelector(selector, data => data[COLOR_PALETTE])
